import React from 'react';
import PropTypes from 'prop-types';
import ImageV2 from 'components_v2/common/ImageV2';
import s from './BudgetHistoryCard.scss';
import { IMAGE_URL } from '../../../constants';

function BudgetHistoryCard({ isStandAlone, data }) {
  const { name, desc, gov, finance_minister, focus_on } = data;
  return (
    <div
      className={`${isStandAlone ? s.bhcStandAlonCard : s.budgetHistoryCard}`}
    >
      <div className={s.bhcContentWrap}>
        <div className={s.bhcHead}>{name}</div>
        <div className={s.bhcInfo}>
          <p>
            Finance Minister <span>{finance_minister}</span>
          </p>
          <p>
            Ruling Government <span>{gov}</span>
          </p>
        </div>
        <p className={s.bhcText}>{desc}</p>
        <div className={s.bhcMajorFocus}>
          <div className={s.bhcMajorText}>Major focus on:</div>
          <div className={s.bhcMajorIconWrap}>
            {focus_on &&
              Array.isArray(focus_on) &&
              focus_on.length > 0 &&
              focus_on.map(
                (item, index) =>
                  index < 2 && (
                    <div className={s.bhcMajorIcons}>
                      <div className={s.bhcMajorImgWrap}>
                        <ImageV2 src={`${IMAGE_URL}/${item.icon}.cms`} alt="" />
                      </div>
                      <div className={s.bhcMajorIconText}>{item.name}</div>
                    </div>
                  ),
              )}
          </div>
        </div>
      </div>
    </div>
  );
}

BudgetHistoryCard.propTypes = {
  isStandAlone: PropTypes.string,
};

BudgetHistoryCard.defaultProps = {
  isStandAlone: '',
};

export default BudgetHistoryCard;
